import { getItemsFromCollection } from "directus/src/operations";

export async function fetchActiveProjectsCount() {
  try {
    const response = await getItemsFromCollection("projects", {
      aggregate: { countDistinct: ["id"] },
      filter: {
        status: { _eq: "active" },
        coordinator: { user: { _eq: "$CURRENT_USER" } },
      },
    });

    return response?.[0]?.countDistinct.id || 0;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchPendingReviewEntriesForProjectCoordinator() {
  try {
    const query = {
      fields: ["logged_hours"],
      filter: {
        approved_hours: { _null: true },
        unapproved_hours: { _null: true },
        logged_hours: { _gt: 0 },
        project: { coordinator: { user: { _eq: "$CURRENT_USER" } } },
        job: { start_date: { _gte: "2024-10-01" } },
      },
      limit: -1,
    };

    const response = await getItemsFromCollection("timesheet", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
